<template>
  <p class="a-input a-input--disabled ">
    {{$t('form.notifications.accreditation-approved')}}
  </p>
</template>

<script>
  export default {
    methods: {
      onClick() {
        this.$router.push({
          name: 'own-accreditation'
        });
      }
    }
  }
</script>

<style scoped>

</style>
